import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { inject, Injectable, PLATFORM_ID } from "@angular/core";

type GTAG = (...args: any[]) => void;
const gtag =
    typeof window !== "undefined"
        ? (window["gtag"] as GTAG)
        : () => {
              return undefined;
          };

/**
 * @description
 * This service handles Google Analytics tracking for page views and events.
 */
@Injectable({
    providedIn: "root",
})
export class AnalyticsService {
    isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
    doc = inject(DOCUMENT);

    init(
        trackingCode: string,
        config: {
            consent?: "granted" | "denied";
        } = {
            consent: this.cookieConsent ? "granted" : "denied",
        },
    ) {
        if (!this.isBrowser || typeof window === "undefined") return;

        gtag("js", new Date());
        gtag("config", trackingCode, { send_page_view: false });

        gtag("consent", "default", {
            ad_storage: config.consent,
            ad_user_data: config.consent,
            ad_personalization: config.consent,
            analytics_storage: config.consent,
        });
    }

    /**
     * @description This will send a page view event to Google Analytics. Make sure GA config is disabling auto page view tracking. gtag("config", "TACKING_CODE",{ 'send_page_view': false });
     * @param url The URL of the page to track.
     */
    trackPageView(url: string) {
        if (!this.isBrowser || typeof window === "undefined" || typeof window["gtag"] !== "function") return;
        this.trackEvent("page_view", {
            page_path: url,
            page_title: document.title,
            page_location: window.location.href,
        });
    }

    trackEvent(eventName: string, params: Record<string, unknown>) {
        if (!this.isBrowser || typeof window === "undefined" || typeof window["gtag"] !== "function") return;
        setTimeout(() => {
            gtag("event", eventName, params);
            // console.log("GA Event", eventName, params);
        }, 0);
    }

    get cookieConsent() {
        return this.isBrowser ? localStorage.getItem("cookieConsent") : "true";
    }

    consentGranted() {
        if (!this.isBrowser || typeof window === "undefined" || typeof window["gtag"] !== "function") return;
        gtag("consent", "update", {
            ad_user_data: "granted",
            ad_personalization: "granted",
            ad_storage: "granted",
            analytics_storage: "granted",
        });
        localStorage.setItem("cookieConsent", "true");
    }
}
